export default __webpack_public_path__ + "static/media/location.fee45110.png";